import { icons, severity, variantsAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
export var alertPROPS = {
    backgroundColor: "",
    description: "",
    iconClose: icons.Close,
    iconCloseColor: "#FFFFFF",
    iconColor: "",
    severity: severity.warning,
    spacing: 0,
    textColor: "",
    title: "",
    variant: variantsAlert.filled,
    autoClose: 10000,
    width: "100%",
};
